import { useState, useEffect } from 'react';
import config from "./config.json";

/*

Añadir forecast de Meteoblue
https://www.meteoblue.com/es/tiempo/pronostico/meteogramone/monta%c3%b1a-de-iza%c3%b1a_espa%c3%b1a_2516417

Hay que descargar previamente haciendo scrapping porque la web usa timestamp y signature


https://my.meteoblue.com/images/meteogram_one?temperature_units=C&windspeed_units=kmh&precipitation_units=mm&darkmode=false&iso2=es&lat=28.3083&lon=-16.5083&asl=2177&tz=Atlantic%2FCanary&dpi=72&apikey=jhMJTOUVRNvs25m4&lang=es&location_name=Monta%C3%B1a+de+Iza%C3%B1a&ts=1759833801&sig=7be70443e260d71b5e04d42f002ee614

*/

function Forecast() {

  // CAMBIAR: usar las coordendas en config
  const lat= config.location.latitude; 
  const lon=config.location.longitude;
  const zoom=6;

  // Windy dust
  let overlay="dustsm";
  let dustUrl = `https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=m/s&zoom=${zoom}&overlay=${overlay}&product=cams&level=800h&lat=${lat}&lon=${lon}&marker=true`;
  let [dustFrameUrl, setImageUrl] = useState(dustUrl);


  // Windy hith clouds
  overlay="hclouds";
  let hcloudsUrl = `https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=default&metricTemp=default&metricWind=default&zoom=${zoom}&overlay=hclouds&product=ecmwf&level=surface&lat=${lat}&lon=${lon}`;
  let [hcloudsFramesUrl, setHcloudsUrl] = useState(hcloudsUrl);

  // Humidity
  overlay="ecmwf";
  let ecmwfUrl = `https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=default&metricTemp=default&metricWind=default&zoom=5&overlay=rh&product=ecmwf&level=surface&lat=${lat}&lon=${lon}&zoom=${zoom}&message=true`;
  let [ecmwfFramesUrl, setEcmwfUrl] = useState(ecmwfUrl);


  useEffect(() => {
    const intervalId = setInterval(() => {
      // Forzar una nueva carga de la imagen añadiendo un timestamp como parámetro
      const timestamp = new Date().getTime();

      setImageUrl(`${dustUrl}?t=${timestamp}`);
      setHcloudsUrl(`${hcloudsUrl}?t=${timestamp}`);
      setEcmwfUrl(`${ecmwfUrl}?t=${timestamp}`);

    }, 5 * 60 * 1000); // 5 minutos en milisegundos

    // Limpia el intervalo cuando el componente se desmonte
    return () => clearInterval(intervalId);
  }, [dustUrl, hcloudsUrl, ecmwfUrl ]); // Dependencia  para que se reinicie si la URL cambia
  

  return (
    <div className='p-3'>


        <div className='row mb-4'>
          
          <div className='col-md-7'>
              {/* Graficos de forecast de AEMET para Izaña */}
              <div className='text-center'>
                <div className='text-light text-center my-2'>
                  <div>AEMet ECMWF forecast for OT</div>
                </div>
                <img src="https://research.iac.es/proyecto/site-testing/meteograms/MeteogramaCEIzanaIAC.PNG" width={"100%"} />
              </div>
              <p className='text-center mt-2 small'>Generated and validated by <a title="Izaña Atmospheric Research Centre (new window)" href="https://izana.aemet.es/" target='_blank'>Izaña Atmospheric Research Centre</a> (CIAI). <div className='text-danger'>This information is not official. Its only purpose is to facilitate the operations and decision making of the User Institutions of the OCAN.</div> </p>
          </div>
          <div className='col-md-5'>
              <iframe width="100%" height="800" src="https://www.meteoblue.com/es/tiempo/widget/seeing/monta%c3%b1a-de-iza%c3%b1a_espa%c3%b1a_2516417?geoloc=fixed&noground=0" frameborder="0"></iframe>
            <a href="https://www.meteoblue.com/es/tiempo/outdoorsports/seeing/monta%c3%b1a-de-iza%c3%b1a_espa%c3%b1a_2516417" target="_blank" rel="noopener">meteoblue</a>
          </div>
        </div>


        {/* Gráficos de forecast de Windy */}
        <div className='row  my-4'>
          <div className='col-md-4'>
            <div className='text-light text-center mb-2'>Dust mass</div>
            <iframe width="100%" height="400" src={dustFrameUrl} frameborder="0"></iframe>
          </div>
          <div className='col-md-4'>
            <div className='text-light text-center mb-2'>High clouds</div>
            <iframe width="100%" height="400" src={hcloudsFramesUrl} frameborder="0"></iframe>
          </div>
          <div className='col-md-4'>
              <div className='text-light text-center mb-2'>Humidity</div>
              <iframe width="100%" height="400" src={ecmwfFramesUrl} frameborder="0"></iframe>
          </div>
        </div>

        

        {/* Modelos de seeing y PWV de skygroup */}
        <div className='row mb-4'>
          <div className='col-md-6'>
            <div className='text-light text-center my-2'>OT 72-hour Seeing forecast: &lambda;=500nm, airmass=1 - <span className='text-danger'>Under validation</span></div>
            <iframe class="bg-light" width="100%" height="480" src="https://dedo.ll.iac.es/media/timeseries_OT_seeing.html" frameborder="0"></iframe>
          </div>
          <div className='col-md-6'>
            <div className='text-light text-center my-2'>OT 72-hour PWV forecast</div>
            <iframe class="bg-white" width="100%" height="480" src="https://dedo.ll.iac.es/media/timeseries_OT_pwv.html" frameborder="0"></iframe>
          </div>
        </div>
        <p className='text-end'>Data from the <a title="Go to the IAC's Forecasting for the Observatories servide website (new window)" href="https://dedo.ll.iac.es/info/" target='_blank'>Forecasting the Observatories</a> (ForO)</p>


       

    </div>
  );

}

export default Forecast;